<template>
  <v-tour name="tour" :steps="steps" :options="options" :callbacks="callbacks">
  </v-tour>
</template>

<script>
export default {
  name: "DocumentsSignTourComponent",
  data() {
    return {
      callbacks: {
        onSkip: this.tourStepFinish,
        onFinish: this.tourStepFinish
      },
      options: {
        useKeyboardNavigation: false,
        labels: {
          buttonSkip: "Cerrar",
          buttonPrevious: "Anterior",
          buttonNext: "Continuar",
          buttonStop: "Finalizar"
        }
      },
      steps: [
        {
          target: "#app",
          content: `
            <h5>Paso 1 de 4</h5>
            <h6>Firma documentos PDF en minutos</h6>
            <p>Sube cualquier PDF y prepáralo para firma electrónica con valor legal en Ecuador, sin imprimir ni escanear.</p>
          `
        },
        {
          target: "#app",
          content: `
            <h5>Paso 2 de 4</h5>
            <h6>Define quién firma y dónde</h6>
            <p>Agrega uno o varios firmantes, asigna campos de firma e iniciales y envía la solicitud por correo.</p>
          `
        },
        {
          target: "#app",
          content: `
            <h5>Paso 3 de 4</h5>
            <h6>Sigue el estado en tiempo real</h6>
            <p>Filtra por enviado, visto, firmado o cancelado. Te avisamos cuando cada firmante completa su parte.</p>
          `
        },
        {
          target: "#app",
          content: `
            <h5>Paso 4 de 4</h5>
            <h6>Valida cualquier documento firmado</h6>
            <p>Usa el botón Validar para verificar la integridad y firma de un PDF, propio o de terceros.</p>
          `
        }
      ]
    };
  },
  methods: {
    tourStepFinish() {
      const userConfigGeneral = {
        is_documents_sign_tour_completed: 1
      };
      this.$store.dispatch("userConfigGeneralUpdated", userConfigGeneral);
    }
  },
  mounted() {
    this.$tours["tour"].start();
  }
};
</script>

<style lang="scss" scoped></style>
